import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  initialState,
  searchGeblokkeerdeWeken,
} from '../../../planning/services/searchGeblokkeerdeWeken'
import type { ProjectenPlanningSearchFilters } from '../types/ProjectenPlanningSearch'

export { usePlanningGeblokkeerdeWeken, queryKey }

const queryKey = 'hoofdleiding-planning-geblokkeerde-weken'

const usePlanningGeblokkeerdeWeken = ({
  gebied,
  combi,
}: Pick<ProjectenPlanningSearchFilters, 'gebied' | 'combi'>) => {
  const { hasPermissions } = useAuthenticatedUser()

  const query = {
    ...initialState.query,
    filters: { gebied, organisatie: combi },
  }

  const { data, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => searchGeblokkeerdeWeken({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
  }
}
